module.exports = __webpack_public_path__ + "static/media/gold_pattern.bed77526.png";